import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type Replay10IconProps = IconProps;

export const Replay10Icon = forwardRef<SVGSVGElement, Replay10IconProps>(
  function Replay10Icon(props: Replay10IconProps, ref) {
    return (
      <Icon
        data-testid="Replay10Icon"
        aria-label="replay 10"
        viewBox="0 0 12 12"
        ref={ref}
        {...props}
      >
        <path d="M7.979 2c2.249 0 4.061 1.835 4.02 4.071C11.96 8.252 10.171 10 7.979 10H4v2L0 9.5 4 7v2h3.979a3.008 3.008 0 0 0 3.015-2.946A3.008 3.008 0 0 0 7.979 3V2zM2.545 5.25h-.807V2.034l.003-.321.007-.314c.005-.103.01-.201.017-.294a2.318 2.318 0 0 1-.178.171 7.906 7.906 0 0 1-.219.191l-.574.458-.403-.509L1.874.254h.67v4.997z" />
        <path d="M7.073 2.748c0 .403-.032.764-.096 1.083-.062.317-.16.586-.294.807s-.31.39-.526.506a1.644 1.644 0 0 1-.786.174c-.385 0-.703-.101-.954-.304-.251-.205-.436-.499-.557-.882-.121-.385-.181-.847-.181-1.384s.055-.998.164-1.381c.112-.385.292-.68.54-.885s.578-.308.988-.308c.387 0 .706.103.957.308.253.203.44.497.561.882.123.383.185.844.185 1.384zm-2.584 0c0 .422.027.774.082 1.056.057.283.15.494.28.636.13.139.303.209.52.209s.39-.07.52-.209c.13-.139.223-.35.28-.632.059-.283.089-.636.089-1.06 0-.419-.028-.77-.085-1.053s-.15-.494-.28-.636c-.13-.144-.304-.215-.523-.215s-.393.072-.523.215c-.128.141-.22.353-.277.636a5.642 5.642 0 0 0-.082 1.053z" />
      </Icon>
    );
  }
);
